

import React, { memo } from 'react';
import cx from 'classnames';
import Icon from '../../Icon';
import { Image } from '../../Image';
import Text from '../../Text';
import '../styles/_review-member.scss';

const DEFAULT_IMAGE_SIZE = '40px';

const TEXT_SIZE = {
  SMALL: 10,
  BIG: 14
};








const ReviewMember = ({ className = '', member, imageSize = DEFAULT_IMAGE_SIZE, small }) => {
  const { userId, name, firstName, lastName, imageUrl } = member;
  const memberName = name || `${firstName} ${lastName}`;
  const placeholderTextSize = small ? TEXT_SIZE.SMALL : TEXT_SIZE.BIG;

  return (
    <div key={userId} className={cx('review-member', className)}>
      <Image
        height={imageSize}
        width={imageSize}
        circular
        imageUrl={imageUrl}
        placeholderText={memberName}
        placeholderTextSize={placeholderTextSize}
        backgroundSize="cover" />


      <div className="review-member__eye">
        <Icon
          color="white"
          name="show"
          size={12} />

      </div>

      <div className="review-member__info">
        <Text className="review-member__text">
          <span>
            {memberName}
            <br />
            is currently reviewing
          </span>
        </Text>
      </div>
    </div>);

};

export default memo(ReviewMember);